import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import CustomBackdrop from '../../../../components/backdrop';
import getEnvironement from '../../../../environnement';
import CustomInput from '../../../../components/customInput';

export default function AddDialog({
  open,
  handleOpen,
  handleClose,
  reloadData,
}) {
  const [consommable, setConsommable] = useState('');
  const [consommableEn, setConsommableEn] = useState('');
  const [consommableError, setConsommableError] = useState('');
  const [consommableEnError, setConsommableEnError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function addConsommable() {
    const url = `${getEnvironement().API_URL}/consommables`;
    const data = {
      consommable,
      consommableEn
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => reloadData())
      .then(() => setTimeout(() => toast.success('Le consommable a bien été ajouté'), 800))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.consommable ? setConsommableError(err.response.data.errors.consommable[0]) : setConsommableError('');
          err.response.data.errors.consommableEn ? setConsommableEnError(err.response.data.errors.consommableEn[0]) : setConsommableEnError('');
          handleOpen();
        }
      });
  }

  useEffect(() => {
    setConsommable('');
    setConsommableEn('');
    if (!open) {
      setConsommableError('');
      setConsommableEnError('');
    }
  }, [open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Ajouter un consommable :</p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomInput
              type='text'
              placeholder='Consommable'
              value={consommable}
              setValue={setConsommable}
              isError={consommableError !== ''}
              error={consommableError}
            />
            <CustomInput
              type='text'
              placeholder='Consommable (anglais)'
              value={consommableEn}
              setValue={setConsommableEn}
              isError={consommableEnError !== ''}
              error={consommableEnError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={addConsommable}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Ajouter</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
